import type { AuthUser } from '@eriko/shared-types';
import { publicClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface AdminLoginResponse {
  user: AuthUser;
  tokens: { accessToken: string; refreshToken: string };
}

export async function adminLogin(email: string, password: string): Promise<AdminLoginResponse> {
  const res = await publicClient.post<AdminLoginResponse>(ENDPOINTS.adminAuth.login, {
    email,
    password,
  });
  return res.data;
}
